<ion-button
  [fill]="settings.fill"
  [expand]="settings.expand"
  [shape]="settings.shape"
  [color]="settings.color"
  [disabled]="settings.disabled"
>
  <ion-icon [slot]="settings.icon.slot" [name]="settings.icon.name"></ion-icon>
  {{ label }}
</ion-button>
